import { render, staticRenderFns } from "./FileUploadImagePreview.vue?vue&type=template&id=bdc25f48&scoped=true"
import script from "./FileUploadImagePreview.vue?vue&type=script&lang=js"
export * from "./FileUploadImagePreview.vue?vue&type=script&lang=js"
import style0 from "./FileUploadImagePreview.vue?vue&type=style&index=0&id=bdc25f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc25f48",
  null
  
)

export default component.exports